const horseGIFPos = [  require('../../images/horse/pos/1.png'), require('../../images/horse/pos/2.png'), 
                        require('../../images/horse/pos/3.png'), require('../../images/horse/pos/4.png'),
                        require('../../images/horse/pos/5.png'), require('../../images/horse/pos/6.png'), 
                        require('../../images/horse/pos/7.png'), require('../../images/horse/pos/8.png'),
                  ];

const horseGIFNeg = [  require('../../images/horse/neg/1.png'), require('../../images/horse/neg/2.png'), 
                        require('../../images/horse/neg/3.png'), require('../../images/horse/neg/4.png'),
                        require('../../images/horse/neg/5.png'), require('../../images/horse/neg/6.png'), 
                        require('../../images/horse/neg/7.png'), require('../../images/horse/neg/8.png'),
            ];

module.exports = {horseGIFPos, horseGIFNeg}